import React from 'react';
import { Text } from 'rebass';

const ErrorText: React.FC<{ message: string }> = ({ message }) =>
  message ? (
    <Text variant="body2" color="statusError" role="alert">
      {message}
    </Text>
  ) : null;

export default ErrorText;
